document.querySelectorAll('.card').forEach(item => {
    item.addEventListener('click', () => {
        alert('fjskdj');
    })
})